import { Circle } from "@phosphor-icons/react"
import classNames from "classnames"

export type CheckboxProps = {
  isChecked: boolean
  onChange: (checked: boolean) => void
  className?: string
  peer?: boolean
  disabled?: boolean
}

export function Checkbox({
  className,
  isChecked,
  peer,
  onChange,
  disabled,
}: CheckboxProps) {
  const style = classNames(
    "inline-block h-6 w-6 cursor-pointer rounded-full print:bg-main-light print:border print:border-main-700 print:flex print:items-center print:justify-center",
    {
      "bg-secondary-500": peer && isChecked,
      "bg-primary-500": !peer && isChecked,
      "bg-main-light border-2 border-secondary-500": peer && !isChecked,
      "border-2 border-primary-500": !peer && !isChecked,
    },
    "print:border-0 print:bg-transparent print:shadow-none",
    className
  )

  return (
    <div
      className={style}
      onClick={disabled ? () => {} : () => onChange(!isChecked)}>
      <Circle
        weight="fill"
        className={`hidden h-6 w-6 sm:h-8 sm:w-8 ${!peer ? "fill-primary-500" : "fill-secondary-500 "} ${isChecked ? "print:block" : ""}`}
      />
    </div>
  )
}
